import { colorTool, rectTool } from "../tv";
import { LevelLiqType } from "./smpainfo";
import { styleSet } from "./styles";
import { markTools } from "./tools";

export interface dirTool<Tool> {
	tool: Tool;
	isBull: boolean;
	style?: styleSet;
	txt?: boolean;
	p?: any;
}

interface sessionTool {
	tool: rectTool;
	type: LevelLiqType;
}

export class markToolsSet {
	dirTools: dirTool<colorTool>[] = [];

	sessions: sessionTool[] = [];

	constructor(tool: markTools) {

	}
	clear() {
		
		for (const p of this.dirTools)
			p.tool?.clear();
		
		this.dirTools = [];

		for (const p of this.sessions)
			p.tool?.clear();

		this.sessions = [];
	}
	
	addDirTool(style: styleSet, tool: colorTool, isbull: boolean, txt = false, p: any = null) {
		const dt = {
			isBull: isbull,
			tool: tool,
			style: style,
			txt: txt,
			p: p
		};
		this.dirTools.push(dt);
	}

	addSession(tool: rectTool, type: LevelLiqType) {
		this.sessions.push({
			type: type,
			tool: tool
		});
	}
}
